'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["companyId", "displayName", "domain", "email", "existsInPortal", "fetchAvatars", "fileManagerKey", "hubSpotUserEmail", "lookup", "primaryIdentifier", "secondaryIdentifier", "socialNetwork", "src", "type", "vid"];
import pickToolTipName from './UIAvatarDisplay/pickToolTipName';
import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import styled from 'styled-components';
import UIAvatarRequest from './UIAvatarRequest';
import { AVATAR_SIZES } from './Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarListWrapper = styled('div').withConfig({
  displayName: "UIAvatarMultiOrSingle__AvatarListWrapper",
  componentId: "sc-1ipmxzr-0"
})(["display:flex;flex-direction:row-reverse;justify-content:flex-end;"]);
class UIAvatarMultiOrSingle extends Component {
  makeNumberAvatar() {
    const {
      _truncateAvatarListInTooltip,
      hasMoreHref,
      lookup,
      maxAvatars
    } = this.props;
    const offsetMax = maxAvatars - 1;
    const remainingAvatarsNumber = lookup.length - offsetMax;
    const remainingAvatarsNumberLimit = remainingAvatarsNumber > 9 ? 9 : remainingAvatarsNumber;
    const remainingAvatars = lookup.slice(offsetMax, offsetMax + 9);
    const hasMoreAvatarDisplay = remainingAvatarsNumber ? '+' : '';
    let displayList = this.avatarsToDisplayList(remainingAvatars);
    if (_truncateAvatarListInTooltip && remainingAvatars.length < remainingAvatarsNumber) {
      // i18n-lint-disable-next-line require-i18n-message
      displayList = I18n.text('uiAddonAvatars.tooltip.hasMore', {
        list: displayList
      });
    }
    return {
      displayName: `${remainingAvatarsNumberLimit} ${hasMoreAvatarDisplay}`,
      _isHasMore: true,
      href: hasMoreHref,
      _toolTipOverWrite: displayList
    };
  }
  avatarsToDisplayList(arrayOfObjects) {
    return arrayOfObjects.map(pickToolTipName).join(', ');
  }
  renderAvatarList() {
    const {
      _hasMoreOverWrite,
      childClassName,
      childStyles,
      className,
      lookup,
      maxAvatars,
      portalId,
      fetchAvatars,
      size,
      toolTipPlacement
    } = this.props;
    const isHiddenAvatars = !!_hasMoreOverWrite || lookup.length > maxAvatars;
    const newLookupList = isHiddenAvatars ? lookup.slice(0, maxAvatars - 1) : lookup.slice(0);
    if (isHiddenAvatars) {
      newLookupList.push(this.makeNumberAvatar());
    }
    return /*#__PURE__*/_jsx(AvatarListWrapper, {
      className: className,
      children: newLookupList.reverse().map((lookupObj, i) => {
        const avatarLookupWithReverse = Object.assign({
          className: childClassName,
          _isListReversed: true,
          portalId,
          fetchAvatars,
          size,
          style: childStyles,
          toolTipPlacement
        }, lookupObj);
        return this.renderSingleAvatar(avatarLookupWithReverse, i);
      })
    });
  }
  renderSingleAvatar(props, key) {
    const {
        companyId,
        displayName,
        domain,
        email,
        existsInPortal,
        fetchAvatars,
        fileManagerKey,
        hubSpotUserEmail,
        lookup,
        primaryIdentifier,
        secondaryIdentifier,
        socialNetwork,
        src,
        type,
        vid
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const proxyLookup = lookup || {};
    return /*#__PURE__*/_jsx(UIAvatarRequest, Object.assign({}, Object.assign({
      companyId: companyId || proxyLookup.companyId,
      displayName: displayName || proxyLookup.displayName || email || proxyLookup.email || domain || proxyLookup.domain || secondaryIdentifier || proxyLookup.secondaryIdentifier || primaryIdentifier || proxyLookup.primaryIdentifier,
      domain: domain || proxyLookup.domain,
      email: email || proxyLookup.email,
      existsInPortal: existsInPortal || proxyLookup.existsInPortal,
      fetchAvatars,
      fileManagerKey: fileManagerKey || proxyLookup.fileManagerKey,
      hubSpotUserEmail: hubSpotUserEmail || proxyLookup.hubSpotUserEmail,
      key,
      primaryIdentifier: primaryIdentifier || proxyLookup.primaryIdentifier,
      socialNetwork: proxyLookup.socialNetwork || socialNetwork,
      secondaryIdentifier: secondaryIdentifier || proxyLookup.secondaryIdentifier,
      src: src || proxyLookup.src,
      type: type || proxyLookup.type,
      vid: vid || proxyLookup.vid
    }, rest)));
  }
  render() {
    const {
      lookup
    } = this.props;
    if (lookup && Array.isArray(lookup)) {
      return this.renderAvatarList();
    }
    return this.renderSingleAvatar(this.props);
  }
}
const PropTypeChildClassName = (props, propName, componentName, ...rest) => {
  PropTypes.string(props, propName, componentName, ...rest);
  if (props[propName] && !Array.isArray(props.lookup)) {
    return new Error(`${componentName}: ${propName} is only applied when lookup is an array.`);
  }
  return null;
};
const PropTypeChildStyles = (props, propName, componentName, ...rest) => {
  PropTypes.string(props, propName, componentName, ...rest);
  if (props[propName] && !Array.isArray(props.lookup) && props.lookup.length > 1) {
    return new Error(`${componentName}: ${propName} is only applied when lookup is an array that can make children.`);
  }
  return null;
};
const PropTypeMaxAvatars = (props, propName, componentName) => {
  if (props[propName] < 2) {
    return new Error(`${propName} needs to be at least 2 in ${componentName}.`);
  }
  return null;
};
const PropTypeHasMoreHref = (props, propName, componentName) => {
  if (props[propName] && !props.maxAvatars) {
    return new Error(`${propName} will only work if maxAvatars is set in ${componentName}`);
  }
  return null;
};
UIAvatarMultiOrSingle.propTypes = Object.assign({}, UIAvatarRequest.propTypes, {
  _truncateAvatarListInTooltip: PropTypes.bool,
  childClassName: PropTypeChildClassName,
  childStyles: PropTypeChildStyles,
  className: PropTypes.string,
  fetchAvatars: PropTypes.func,
  hasMoreHref: PropTypeHasMoreHref,
  lookup: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  maxAvatars: PropTypeMaxAvatars,
  portalId: PropTypes.number,
  size: PropTypes.oneOf(Object.keys(AVATAR_SIZES))
});
export default UIAvatarMultiOrSingle;